// extracted by mini-css-extract-plugin
module.exports = {"accordion":"part-accordion_accordion__FPD4z"};